import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface ISpatialReference {
  latestWkid: number | undefined;
  wkid: number | undefined;
}

export interface IExtent {
  spatialReference: ISpatialReference;
  xmax: number | undefined;
  xmin: number | undefined;
  ymax: number | undefined;
  ymin: number | undefined;
}

export const SpatialReference = types.model('SpatialReference', {
  latestWkid: types.maybe(types.number),
  wkid: types.maybe(types.number)
});

export const Extent = types.model('Extent', {
  spatialReference: SpatialReference,
  xmax: types.maybe(types.number),
  xmin: types.maybe(types.number),
  ymax: types.maybe(types.number),
  ymin: types.maybe(types.number)
});

export interface IExtentInstance extends Instance<typeof Extent> {}
export interface IExtentSnapshotIn extends SnapshotIn<typeof Extent> {}
export interface ISpatialReferenceSnapshotIn extends SnapshotIn<typeof SpatialReference> {}
export interface ISpatialReferenceInstance extends Instance<typeof SpatialReference> {}
